export default __webpack_public_path__ + "static/artifakt-legend-bold-184615c61efa6fdd363a284e810620af.ttf";